import instance from "./instance";

const voucherUrl = "/auth/v1/user/voucher";
export const getPremiumAccountRenewal = (voucher) => {
  // checkAndCallDailyLoginAPI()
  return instance.get(`${voucherUrl}/premium-account-renewal/${voucher}`);
};
